<div class="row" *ngIf="sharedService.currentDrawer.title == 'Edit Label'">
    <div class="col-sm-6">
        <div class="c-form-group">
            <div class="c-form-group__label"><label for="sectionLabel">Section Label</label></div>
            <input id="sectionLabel"
                cclFormInput
                type="text"
                class="c-form-group__input c-input--required"
                [(ngModel)]="labelConfig.label"
                maxlength="100"
            />
            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>
    <div class="col-sm-6">
        <div class="c-form-group">
            <div class="c-form-group__label"><label for="fontColor">Font Color</label></div>
            <div
                class="input-group"
                [(colorPicker)]="labelConfig.fontColor"
                [cpAlphaChannel]="'disabled'"
                [cpOutputFormat]="'hex'"
                [cpPosition]="'left'"
            >
                <input id="fontColor"
                    cclFormInput
                    type="text"
                    [(ngModel)]="labelConfig.fontColor"
                    class="c-form-group__input form-control"
                />

                <div class="input-group-append">
                    <span
                        class="c-color-picker input-group-text"
                        [ngStyle]="{ 'background-color': labelConfig.fontColor }"
                        >&nbsp;</span
                    >
                </div>
            </div>

            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>
    <div class="col-sm-6">
        <div class="c-form-group">
            <div class="c-form-group__label"><label for="fontStyle">Font Style</label></div>
            <ccl-simple-select formId="fontStyle"
                [listOfItems]="sharedService.fontStyles"
                (valueChange)="labelConfig.fontStyle = $event.value"
                [value]="labelConfig.fontStyle"
                [bindValue]="'id'"
                [bindLabel]="'label'"
                [isClearable]="false"
            ></ccl-simple-select>
            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>
    <div class="col-sm-6">
        <div class="c-form-group">
            <div class="c-form-group__label"><label for="fontSize">Font Size</label></div>
            <ccl-simple-select formId="fontSize"
                [listOfItems]="sharedService.fontSizes"
                (valueChange)="labelConfig.fontSize = $event.value"
                [value]="labelConfig.fontSize"
                [bindValue]="'id'"
                [bindLabel]="'label'"
            ></ccl-simple-select>
            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>
</div>

<div class="row" *ngIf="sharedService.currentDrawer.title != 'Edit Label'">
    <div class="col-sm-12">
        <div class="c-form-group">
            <div class="c-form-group__label"><label for="sectionLabel">Search Bar Text</label></div>
            <input id="sectionLabel"
                cclFormInput
                type="text"
                class="c-form-group__input c-input--required"
                [(ngModel)]="searchBarConfig.searchBarText"
                maxlength="100"
            />
            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>
</div>
